module.exports = __webpack_public_path__ + "img/60m5.83a3ed94.jpg";